<script>
import {mapActions} from "vuex";
import InfiniteAutocomplete from "./InfiniteAutocomplete.vue";

/**
 * 排出事業者・事業場選択コンポーネント
 *
 */
export default {
  name: "InfiniteBillingAutoComplete",
  components: {
    InfiniteAutocomplete,
  },
  props: {
    /**
     * 事業者ID
     */
    billingId: {
      type: Number,
      default: () => null,
    },
    /**
     * 事業者ラベル
     */
    label: {
      type: String,
      default: "排出事業者",
    },
    /**
     * 事業者 必須
     */
    required: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: null,
    },
    selfTenant: {
      type: Boolean,
      default: () => false,
    },
    exclusionIds: {
      type: Array,
      default: () => [],
    },

  },
  data() {
    return {
      loading: false,
      searchKeyword: null,
      timerId: undefined,
      pageNumber: 0,
      billings: [],
      pagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },
      workableId: null,
    };
  },
  computed: {},
  watch: {
    /**
     * 排出事業者IDの変更検知
     * @param newValue 排出事業者ID
     * @param oldValue
     */
    billingId(newValue, oldValue) {
      this.workableId = newValue;
      if (newValue !== oldValue) {
        this.loadBilling(this.workableId)
      }
    },
    /**
     * 作業用排出事業場IDの変更検知
     */
    workableId() {
      this.returnCurrentValues();
    },
  },
  created() {
    if (this.billingId) {
      this.workableId = this.billingId;
      this.loadBilling(this.workableId);
    } else {
      this.fetchBillingMembers();
    }
  },
  methods: {
    ...mapActions("DriverMasterSearchBillingAddressMember", {
      fetchBillings: "index",
    }),
    loadBilling(id) {
      const conditions = {
        name: null,
        target_id: id,
        self_tenant: this.selfTenant,
        page: 1,
      };

      this.fetchBillings({ params: conditions }).then((response) => {
        this.billings = response.billing_addresses;
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      });
    },
    /**
     * 排出事業者のリロード処理
     */
    reloadBillings() {
      this.searchKeyword = null;
      this.pageNumber = 0;
      this.billings = [];
      Object.assign( this.$data.pagination, this.$options.data().pagination );
      this.fetchBillingMembers();
    },
    /**
     * 排出事業者オプション取得アクション
     * @returns {Promise<unknown>}
     */
    fetchBillingMembers() {
      this.loading = true;
      const conditions = {
        query: this.searchKeyword,
        page: this.pageNumber,
        self_tenant: this.selfTenant,
      };
      this.fetchBillings({ params: conditions })
        .then((response) => {
          this.billings = this.billings.concat(response.billing_addresses);
          this.pagination = response.pagination;
          this.pageNumber = response.pagination.current_page;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 排出事業者 チェンジイベント
     */
    changeCallback() {
    },
    /**
     * 事業者クリア コールバック
     */
    clearCallback() {
      this.workableId = null;
      this.reloadBillings();
    },
    /**
     * 排出事業者
     * 次ページ読込
     */
    insectCallback() {
      if (this.pageNumber > 0) {
        this.pageNumber++;
        this.fetchBillingMembers();
      }
    },
    enterKeydownCallback (value) {
      this.pageNumber = 0;
      this.searchKeyword = value;
      this.fetchBillingMembers();
    },
    returnCurrentValues() {
      this.$emit("update:values", this.workableId);
    },
  },
};
</script>
<template>
  <div>
    <validation-provider
      v-slot="{ errors }"
      :value="workableId"
      :rules="{ required: required }"
      :class="{ requiredMark: required }"
      :name="label"
    >
      <InfiniteAutocomplete
        v-model="workableId"
        :classes="classes"
        :label="label"
        :disabled="disabled"
        :errorMessages="errors"
        :loading="loading"
        :members="billings"
        :pagination="pagination"
        :rounded="rounded"
        item-text="label"
        @change="changeCallback"
        @click:clear="clearCallback"
        @insect="insectCallback"
        @keydown:enter="enterKeydownCallback"
      >
        <template v-slot:prepend>
          <slot name="prepend" />
        </template>
        <template v-slot:prepend-inner>
          <slot name="prepend-inner" />
        </template>
        <template v-slot:selection="{ item }">
          <slot
            name="selection"
            v-bind:item="item"
          >
            {{ item.label }}
          </slot>
        </template>
        <template v-slot:item="{ item }">
          <slot name="item" v-bind:item="item">
            {{ item.label }}
          </slot>
        </template>
        <template v-slot:append>
          <slot name="append" />
        </template>
        <template v-slot:append-outer>
          <slot name="append-outer" />
        </template>
      </InfiniteAutocomplete>
    </validation-provider>
  </div>
</template>
